import axios from 'axios';
import { apiEndpoint } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';

/**
 * Create or update a spray session
 * @param {Object} data - The spray session data
 * @param {number} data.spray_job_id - The ID of the spray job
 * @param {Array} data.zones - Array of zone objects
 * @param {number} [data.nozzle_image_id] - ID of the nozzle image
 * @param {number} [data.tractor_image_id] - ID of the tractor image
 * @param {number} [data.sprayer_image_id] - ID of the sprayer image
 * @param {number} [data.tractor_settings_image_id] - ID of the tractor settings image
 * @param {number} [data.sprayer_settings_image_id] - ID of the sprayer settings image
 * @returns {Promise<Object>} The API response
 */
function createOrUpdate(data) {
  return axios
    .post(`${apiEndpoint.spraySessions}`, data, {
      headers: {
        ...authHeader(),
        'Content-Type': 'application/json',
      },
    })
    .then((res) => {
      if (res && res.status === 200 && res.data.code === '0000') {
        return res.data;
      }
      throw new Error(res?.data?.message || 'Failed to save spray session');
    })
    .catch((error) => {
      console.error('Error in createOrUpdate spray session:', error);
      throw error;
    });
}

export const spraySessionService = {
  createOrUpdate,
};
